import { jsxs, jsx } from 'react/jsx-runtime';
import { a as EGDSIcon, E as EGDSIconSize } from '../icon/index-chunk.esm.js';
import { c as classNames } from '../theme-provider/index-chunk.esm.js';
import styles from '../styles/uitk-egds-rating.css';

const EGDSRatingIconMap = [
    ['star', 'star'],
    ['alternate', 'brightness_1'],
];
const EGDSRatingIcons = new Map(EGDSRatingIconMap);

const getClassNameList = classNames.bind(styles);
const EGDSRating = (props) => {
    const { a11yText, icon = 'star', rating, className } = props;
    const max = 5;
    const currentRating = Number(rating);
    if (currentRating > max || !currentRating) {
        currentRating > max && console.error(`Maximum value is ${max}`);
        return null;
    }
    const visuallyHiddenText = a11yText
        ? a11yText.replace(/%s/, `${currentRating}`).replace(/%d/, `${max}`)
        : `${currentRating} out of ${max}`;
    const ratingArr = Number.isInteger(currentRating)
        ? // @ts-ignore
            [...Array(currentRating).keys()]
        : [...Array(Math.floor(currentRating)).keys()].concat([currentRating - Math.floor(currentRating)]);
    const wrapperClassNames = getClassNameList('uitk-rating', className);
    const iconType = icon && EGDSRatingIcons.get(icon);
    return (jsxs("div", { className: wrapperClassNames, children: [jsx("span", { className: "is-visually-hidden", children: visuallyHiddenText }), ratingArr.map((val, index) => (jsx(EGDSIcon, { name: Number.isInteger(val) ? `${iconType}` : `${iconType}_half`, size: EGDSIconSize.EXTRA_SMALL, className: getClassNameList('uitk-rating-icon') }, index)))] }));
};

export { EGDSRating as E, EGDSRatingIcons as a };
//# sourceMappingURL=index-chunk.esm.js.map
